<template>
  <div>
    <vs-prompt
      title="Remove User from Board"
      @accept="deleteBoardUser"
      accept-text="Confirm"
      :active.sync="confirmBoardUserDeletion"
    >
      <div v-if="params.data.userData && params.data.userData.firstName">
        Are you sure, you want to remove
        <b
          >{{ params.data.userData.firstName }}
          {{ params.data.userData.lastName }}</b
        >
        from this board?
      </div>
      <div v-else>
        Are you sure, you want to remove
        <b>{{ params.data.userData.email }}</b> from this board?
      </div>
    </vs-prompt>
    <span>
        <vs-button text-color="black" type="flat" style="padding:0">
          <vx-tooltip class="cursor-pointer" text="Edit" position="bottom">
            <feather-icon
              icon="Edit3Icon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="editRecord(params.value)"
            />
          </vx-tooltip>
        </vs-button>
    </span>
    <span>
        <vs-button text-color="black" type="flat" style="padding:0">
          <vx-tooltip class="cursor-pointer" text="Sent Invitation" position="bottom">
            <feather-icon
              v-if="params.data.status === 'invite-sent'"
              icon="SendIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="resendBoardInvitationLink(params.value)"
            />
          </vx-tooltip>
        </vs-button>
    </span>
    <span>
        <vs-button text-color="black" type="flat" style="padding:0">
          <vx-tooltip class="cursor-pointer" text="Delete" position="bottom">
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="confirmBoardUserDeletion=true"
            />
          </vx-tooltip>
        </vs-button>
    </span>
      <!-- <feather-icon
        icon="Edit3Icon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="editRecord(params.value)"
      />
      <feather-icon
        v-if="params.data.status === 'invite-sent'"
        icon="SendIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="resendBoardInvitationLink(params.value)"
      />
      <feather-icon
        icon="Trash2Icon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="confirmBoardUserDeletion=true"
      /> -->
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  data() {
    return {
      confirmBoardUserDeletion: false
    }
  },
  methods: {
    editRecord(email) {
      this.$parent.$emit("editBoardUser", email);
    },
    resendBoardInvitationLink(email) {
      this.$parent.$emit("resendBoardInvitationLink", email);
    },
    deleteBoardUser() {
      this.$parent.$emit("deactivateBoardUser", this.params.data);
    },
  },
};
</script>
